import { render, staticRenderFns } from "./MdPatientContacts.vue?vue&type=template&id=2015c351&"
import script from "./MdPatientContacts.vue?vue&type=script&lang=js&"
export * from "./MdPatientContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports